// @react/hooks/useTaskStatusDefinition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskStatusDefinitionStore } from '@core/stores';

/**
 * React hook for TaskStatusDefinition operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskStatusDefinition } from '@react/hooks';
 *
 * const TaskStatusDefinitionList = observer(() => {
 *   const store = useTaskStatusDefinition();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskStatusDefinition() {
  return taskStatusDefinitionStore;
}
